export default __webpack_public_path__ + "static/media/phone.b44ea55a.svg";